<template>
  <p :class="getClass()">{{ 'report-of-sickness.states.' + status | translate }}</p>
</template>

<script>
import States from '@/resources/models/states';

export default {
  name: 'ReportOfSicknessStatus',
  props: {
    status: String
  },
  methods: {
    getClass () {
      switch (this.status) {
        case States.Processed:
          return 'ros-status processed';
        case States.Rejected:
          return 'ros-status rejected';
        case States.ToReview:
          return 'ros-status to-review';
        default:
          return 'ros-status nothing';
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.ros-status {
  border-radius: $border-radius;
  padding: 4px 9px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  color: $primary;
  width: fit-content;

  &.nothing {
    color: $primary;
    font-weight: 500;
    padding: 0px 0px;
    background-color: none;
  }

  &.rejected {
    color: white;
    background-color: $error;
  }

  &.to-review {
    background-color: #fff3c9;
    color: #de9400;
  }

  &.processed {
    background-color: $positive;
    color: white;
  }
}
</style>
